<template>
    <div class="document-overview">
        <header>
            <span class="header-text">Document {{documentId}}</span>
        </header>
        <section class="document-description">
            <div v-for="(item,index) in documentDescriptionItems" :key="index">
                <span class="label">{{item.label}}</span>: <span class="value">{{item.value}}</span>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "DTOverview",
        props: {
            documentDescriptionItems: Array,
            documentId: String,
        }
    }
</script>

<style scoped lang="scss">
    .document-overview {
        .document-description {
            & > div {
                margin-bottom: 0.5rem;
            }
        }
    }

    .label {
        color: gray;
        font-weight: 500;
    }

    header {
        margin-bottom: 0.75rem;
        .header-text {
            font-size: 1.15em;
            font-weight: 500;
        }
    }
</style>
